
































import { Component, Prop, Vue } from "vue-property-decorator";
import { RefuelingHistoryEntry } from "@/types/refuelingEvent";

@Component
export default class HistoryChart extends Vue {
    name = "HistoryChart";

    @Prop() refuelings!: RefuelingHistoryEntry[];

    get hasLoaded() : boolean {
        return !!this.refuelings;
    }

    get prices() : number[] {
        return this.ascRefuelings.map((x: RefuelingHistoryEntry) => x.pricePerLiter);
    }

    get ascRefuelings(): RefuelingHistoryEntry[] {
        return [...this.refuelings].reverse();
    }
}
